import React, { PureComponent, Fragment } from "react";
import SelectItem from "react-select";
class SelectSerie extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      item_default: this.props.item_default || [], // Item default
      multiple: this.props.multiple || false, // Indica si es simple o seleccion múltiple
      placeholder: this.props.placeholder || "Cargando...", // Etiqueta Placeholder
      store: this.props.store || [], // Store data [label:,value:]
      nullable: this.props.nullable || false, // No permite seleccion vacia, por defecto selecciona el default
      item_all: this.props.item_all || false,
      item_selected: this.props.item_default || []
    };
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange = event => {
    let me = this;
    if (event === null) {
      event = [];
    }
    let items = [];
    if (me.state.multiple) {
      if (event.length > 0) {
        event.map(function (item) {
          if (me.state.item_all) {
            if (item.value !== me.state.item_default[0].value) {
              items.push(item);
            }
          } else {
            items.push(item);
          }
        });
      } else {
        if (this.state.nullable) {
          items = me.state.item_default;
        }
      }
    } else {
      items = [event];
    }
    this.setState({ item_selected: items });
    this.props.onChange(items);
  };
  componentDidUpdate(prevProps) {
    if (prevProps.item_default.length !== this.props.item_default.length) {
      this.setState({ item_selected: this.props.item_default});
    }
  }
  render() {
    let { multiple, placeholder, store, item_selected } = this.state;
    if (this.props.store.length !== this.state.store.length) {
      store = this.props.store;
    }
    return (
      <Fragment>
        <SelectItem
          isMulti={multiple}
          placeholder={placeholder}
          onChange={this.handleChange}
          value={item_selected}
          options={store}
        />
      </Fragment>
    );
  }
}

export default SelectSerie;
